import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from 'antd';
import { motion } from 'motion/react';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  height: 100dvh;
  width: 70px;
  min-width: 70px;
  max-width: 70px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  background: ${({ theme }) => (theme as any)?.token?.colorBgContainer || '#fff'};
  z-index: 999;
  overflow: hidden;
`;

export const NavScrollArea = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(15, 23, 42, 0.18);
  }
`;

export const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 6px;

  @media (max-height: 700px) {
    gap: 4px;
    padding: 6px 5px;
  }

  @media (max-height: 560px) {
    gap: 3px;
    padding: 5px 4px;
  }
`;

export const Item = styled.div<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s ease;
  color: ${({ $active }) => ($active ? '#393AFB' : 'inherit')};
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  ${({ $active }) =>
    $active &&
    css`
      background: rgba(0, 0, 0, 0.04);
    `};

  @media (max-height: 700px) {
    padding: 3px;
  }

  @media (max-height: 560px) {
    min-height: 38px;
  }
`;

export const ItemIcon = styled.div`
  font-size: 20px;
  color: inherit;
  line-height: 1;

  @media (max-height: 700px) {
    font-size: 18px;
  }
`;

export const ItemLabel = styled.div`
  font-size: 9px;
  line-height: 1.1;
  text-align: center;
  width: 100%;
  white-space: normal;
  /* word-break: break-word; */
  color: inherit;

  @media (max-height: 700px) {
    font-size: 8px;
  }

  @media (max-height: 560px) {
    display: none;
  }
`;

export const BottomBar = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: ${({ theme }) => (theme as any)?.token?.colorBgContainer || '#fff'};

  @media (max-height: 560px) {
    padding: 5px 0;
  }
`;

export const HoverPanel = styled(motion.div)`
  height: auto;
  max-height: 70vh;
  width: 260px;
  background: ${({ theme }) => (theme as any)?.token?.colorBgContainer || '#fff'};
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
  z-index: 1100;
  padding: 12px;
  overflow: auto;
  border-radius: 10px;
`;

export const PanelList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const PanelItem = styled.div<{ $active?: boolean }>`
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
  color: ${({ $active }) => ($active ? '#393AFB' : 'inherit')};
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PanelItemIcon = styled.div`
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  color: inherit;
`;

export const MobileToggle = styled(Button)`
  display: none;
`;

export const MobileOverlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1999;
`;

export const MobileDrawer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  height: 100dvh;
  width: 100vw;
  max-width: none;
  background: ${({ theme }) => (theme as any)?.token?.colorBgContainer || '#fff'};
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const MobileHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: ${({ theme }) => (theme as any)?.token?.colorBgElevated || '#fafafa'};
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  z-index: 1000;
  /* z-index: 1500; */
`;
